import React, { useState } from 'react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';

export default function RenuntaDialog({ open, onClose, motive = [], onConfirm }) {
  const [motiv, setMotiv] = useState('');
  const [saving, setSaving] = useState(false);

  const confirm = async () => {
    if (!motiv) return;
    setSaving(true);
    try {
      await onConfirm(motiv);
      onClose();
      setMotiv('');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="crm-renunta-dialog">
        <DialogHeader>
          <DialogTitle>Renunțare client</DialogTitle>
          <DialogDescription>Alege motivul renunțării. Clientul va fi arhivat (nu se șterge).</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <Label>Motiv (obligatoriu)</Label>
          <select
            data-testid="crm-renunta-motiv"
            className="w-full border rounded-md h-10 px-3 text-sm"
            value={motiv}
            onChange={(e) => setMotiv(e.target.value)}
          >
            <option value="">Alege motivul…</option>
            {motive.map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
          <p className="text-xs text-gray-500">
            Clientul va fi arhivat. Nimic nu se șterge — rămâne în istoric.
          </p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="crm-renunta-cancel">Anulează</Button>
          <Button
            onClick={confirm}
            disabled={!motiv || saving}
            className="bg-red-600 hover:bg-red-700"
            data-testid="crm-renunta-confirm"
          >
            {saving ? 'Se salvează…' : 'Confirmă renunțarea'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
